const TEAL = '#4fd3c4', AMBER = '#e8a94b', DIM = '#93a09b';

export class SunWidget {
  constructor(root) {
    this.root = root;
    this.rsun = this.q('[data-sun-input]');
    this.rsun.addEventListener('input', () => this.update());
    this.update(); // Initialzustand
  }
  q(sel) { return this.root.querySelector(sel); }
  update(){
    const t = parseFloat(this.rsun.value);            // 0..100 Tagesverlauf (Ost → West)
    const sunX = 20 + (t/100)*160;               // Sonne wandert links → rechts
    const sunY = 128 - Math.sin((t/100)*Math.PI)*95; // Bogen, mittags am höchsten
    this.q('[data-sun-disc]').setAttribute('cx', sunX.toFixed(1));
    this.q('[data-sun-disc]').setAttribute('cy', sunY.toFixed(1));

    // Phasen: Rand = Dämmerung, Mitte = Süd/Mittag, sonst Ost- bzw. West-Fassade besonnt
    const dusk = (t < 7 || t > 93);              // Sonne horizontnah → kein Strahlungsfehler
    const noon = (Math.abs(sunX - 100) < 16);    // Sonne im Süden → Ost/West beide neutral

    const chipOst = this.q('[data-sun-chip="ost"]'), chipWest = this.q('[data-sun-chip="west"]');
    const sensOst = this.q('[data-sun-sens="ost"]'), sensWest = this.q('[data-sun-sens="west"]');
    const ray = this.q('[data-sun-ray]');
    let phase, fazit;

    if(dusk){
      phase = (t <= 50) ? 'Dämmerung (früh)' : 'Dämmerung (spät)';
      chipOst.dataset.role = 'neutral'; chipWest.dataset.role = 'neutral';
      this.q('[data-sun-chipstatus="ost"]').textContent  = 'Dämmerung · kein Strahlungsfehler';
      this.q('[data-sun-chipstatus="west"]').textContent = 'Dämmerung · kein Strahlungsfehler';
      sensOst.setAttribute('fill', DIM); sensWest.setAttribute('fill', DIM);
      ray.setAttribute('opacity', '0');
      fazit = 'Dämmerung/Nacht: Keine Fassade besonnt — kein Strahlungsfehler. Die Sensorwahl ist egal, der Mittelwert beider genügt.';
    } else if(noon){
      phase = 'Mittag';
      chipOst.dataset.role = 'neutral'; chipWest.dataset.role = 'neutral';
      this.q('[data-sun-chipstatus="ost"]').textContent  = 'Süd-Sonne · gering besonnt';
      this.q('[data-sun-chipstatus="west"]').textContent = 'Süd-Sonne · gering besonnt';
      sensOst.setAttribute('fill', DIM); sensWest.setAttribute('fill', DIM);
      ray.setAttribute('x1', sunX.toFixed(1)); ray.setAttribute('y1', sunY.toFixed(1));
      ray.setAttribute('x2', '100'); ray.setAttribute('y2', '82'); // aufs Dach (Süd)
      ray.setAttribute('opacity', '0.8');
      fazit = 'Mittag: Die Sonne steht im Süden — Ost- und West-Fassade sind beide kaum besonnt. Kein klarer Favorit, hier greift die Kurzform „kühleren Sensor nehmen".';
    } else if(sunX < 100){
      phase = 'Vormittag';
      chipOst.dataset.role = 'sun'; chipWest.dataset.role = 'active';
      this.q('[data-sun-chipstatus="ost"]').textContent  = 'besonnt · misst zu warm';
      this.q('[data-sun-chipstatus="west"]').textContent = 'Schatten · repräsentativ → aktiv';
      sensOst.setAttribute('fill', AMBER); sensWest.setAttribute('fill', TEAL);
      ray.setAttribute('x1', sunX.toFixed(1)); ray.setAttribute('y1', sunY.toFixed(1));
      ray.setAttribute('x2', '74'); ray.setAttribute('y2', '102'); // Ostfassade
      ray.setAttribute('opacity', '0.8');
      fazit = 'Vormittag: Die Sonne steht im Osten — die Ostfassade wird besonnt, ihr Sensor misst zu warm. Home Assistant nimmt den West-Sensor.';
    } else {
      phase = 'Nachmittag';
      chipOst.dataset.role = 'active'; chipWest.dataset.role = 'sun';
      this.q('[data-sun-chipstatus="ost"]').textContent  = 'Schatten · repräsentativ → aktiv';
      this.q('[data-sun-chipstatus="west"]').textContent = 'besonnt · misst zu warm';
      sensOst.setAttribute('fill', TEAL); sensWest.setAttribute('fill', AMBER);
      ray.setAttribute('x1', sunX.toFixed(1)); ray.setAttribute('y1', sunY.toFixed(1));
      ray.setAttribute('x2', '126'); ray.setAttribute('y2', '102'); // Westfassade
      ray.setAttribute('opacity', '0.8');
      fazit = 'Nachmittag: Die Sonne steht im Westen — die Westfassade wird besonnt. Home Assistant nimmt den Ost-Sensor.';
    }
    this.q('[data-sun-phase]').textContent = phase;
    this.q('[data-sun-fazit]').textContent = fazit;
  }
}
